'use strict';
(function() {
	angular.module('dat.shared-components.common')
		.directive('datInputError', datInputError);

	function datInputError() {
		return {
			link: linkFunction
		};
	}

	function linkFunction(scope, element, attrs) {
		var hideOnBlur = (attrs.hideOnBlur || 'true') === 'true';

		attrs.$observe('datInputError', function (val) {
			if (attrs.datInputErrorFor[attrs.datInputErrorFor.length-1] === '#') return;
			var $input = $(attrs.datInputErrorFor);

			if (val === 'true') {
				// Commenting out so that the tooltip is only shown when focus is set on the field
				//element.addClass('show');
				$input.addClass('ng-invalid-input');
			}
			else {
				element.removeClass('show');
				$input.removeClass('ng-invalid-input');
			}

			$input.on('blur', function () {
				if (hideOnBlur) {
					// hide the bubble, but leave the input border red, when the input loses focus
					element.removeClass('show');
				}
			});

			$input.on('focus', function () {
				// if focus returns and the input is in error, show the bubble again
				if (attrs.datInputError === 'true') {
					element.addClass('show');
				}
			});
		});

	}
})();
